import { useContext } from 'react'
import { HistoryContext } from '../contexts'

export const useExtendedHistory = () => useContext(HistoryContext)
